<template>
  <router-link
    :to="$relativeUrl(data.link)"
    class="thumb"
  >
    <div
      class="thumb-media"
      :class="{
        'has-secondary':
          (data.acf.hover &&
            data.acf.hover.media &&
            data.acf.hover.video &&
            data.acf.hover.video.url) ||
          (data.acf.hover &&
            !data.acf.hover.media &&
            data.acf.hover.image &&
            data.acf.hover.image.url),
      }"
    >
      <Figure
        v-if="data.gds_featured_image"
        :data="{
          value: {
            src: data.gds_featured_image,
          },
          settings: {},
        }"
        theme="default"
        class="primary"
      />
      <template
        v-if="
          data.acf &&
            data.acf.hover &&
            data.acf.hover.media &&
            $mq.breakpoint !== '0' &&
            data.acf.hover.video &&
            data.acf.hover.video.url
        "
      >
        <div class="secondary">
          <video
            :src="data.acf.hover.video.url"
            autoplay
            muted
            loop
            playsinline
          />
        </div>
      </template>
      <template
        v-else-if="
          data.acf &&
            data.acf.hover &&
            data.acf.hover.image &&
            data.acf.hover.image.url &&
            $mq.breakpoint !== '0'
        "
      >
        <Figure
          class="secondary"
          :data="{
            value: {
              src: data.acf.hover.image,
            },
            settings: {},
          }"
          theme="default"
        />
      </template>
    </div>
    <Heading
      class="title"
      :class="$mq.breakpoint === '0' ? 'title-mob' : 'title-dsk'"
      :value="data.title.rendered"
    />
  </router-link>
</template>

<script>
import Figure from '@/components/media/figure';
import Heading from '@/components/typo/heading';

export default {
  name: 'Thumb',
  components: {
    Figure,
    Heading,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.thumb {
  display: block;
  position: relative;
  height: 100%;

  .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--white);
    mix-blend-mode: difference;
    text-align: center;
  }
  .title-dsk {
    @extend %typo--video-title;
  }
  .title-mob {
    @extend %typo--video-title-mobile;
  }
  .thumb-media {
    position: relative;
    z-index: 0;
    height: 100%;

    ::v-deep .image--wrapper {
      height: 100%;
    }

    .secondary {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      ::v-deep .plyr {
        height: 100%;
        width: 100%;
      }

      ::v-deep video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }

    .primary {
      z-index: 1;
      height: 100%;
    }

    .secondary {
      z-index: 2;
      padding: 0;
      opacity: 0;
    }
  }

  @include mq($and: $hover) {
    .title {
      opacity: 0;
    }
    &:hover .title {
      opacity: 1;
    }

    &:hover .thumb-media.has-secondary .primary {
      opacity: 0;
    }

    &:hover .thumb-media.has-secondary .secondary {
      opacity: 1;
    }
  }
}
</style>
